<template>
	<div v-if="authedRoute && !liveFeed.disabled" id="liveFeed">
		<div v-if="liveFeed.open" id="openTradeNewsFeedSection">
			<logo-loader :isActive="localLogoLoaderActive" position="absolute"></logo-loader>
			<div class='newsFeed' :class="[{'update': liveFeed.data[index].update}, ...liveFeed.data[index].cssClass]" v-for="index in liveFeedSorted" :key="liveFeed.data[index].orderID">
				<div class="newsFeedIconContainer">
					<div class="newsFeedIcon"></div>
				</div>
				<div class='newsDataContainer'>
					<p class='accName has-text-primary'><span class='has-text-weight-bold'>{{liveFeed.data[index].accountName}}</span> | {{liveFeed.data[index].tradingAccount}}</p>
					<p>Opened a {{liveFeed.data[index].orderType}} position on {{$simplePair(liveFeed.data[index].pair)}} at {{liveFeed.data[index].openPrice}}</p>
					<p class='has-text-primary likeIcon' :class="{'liked': liveFeed.data[index].liked}" @click="like(index)"></p>
					<p><span class='has-text-primary is-pulled-left'>{{liveFeed.data[index].likeTotal}} likes</span> <span class="is-pulled-right"><div class="clockIcon"></div>{{$dateFromNow(liveFeed.data[index].openDate)}}</span></p>
				</div>
			</div>
		</div>

		<div :class="{'open': liveFeed.open}" id="openTradeNewsFeedMini" @click="liveFeed.open=!liveFeed.open">
			<div class="miniSubSection" v-if="liveFeed.unseen > 0" id="newsFeedCounter">{{liveFeed.unseen}}</div>
			<div class="miniSubSection" id="newsFeedIcon"></div>
			<div class="miniSubSection" v-if="!liveFeed.open" id="maxButton"></div>
			<div class="miniSubSection"	v-if="liveFeed.open" id="maxButton"></div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import config from '../config'
import {service} from '../app'
import logoLoader from './LogoLoader.vue'

export default {
	components: {
		logoLoader,
	},
	data() {
		return {
			liveFeed: {
				disabled: false,
				open: null,
				unseen: 0,
				data: {},
				empty: false,
			},
			liveFeedMode: 'normal',
			conn: null,
			localLogoLoaderActive: false,
			delay: {
				n: null,
				t: 200,
				tries: {
					c: 0,
					max: 10,
				}
			},
			currenDayIndex: moment().weekday(),
		}
	},
	watch: {
		'liveFeed.open'(o) {
			if (o) {
				this.animateUpdate()
				this.liveFeed.unseen = 0
			}
		},
		'liveFeed.empty'(o) {
			this.liveFeed.open = !o
		}
	},
	computed: {
		authedRoute() {
			return this.$route.meta.auth
		},
		liveFeedSorted() {
			let k = Object.keys(this.liveFeed.data)
			if (!k.length) {
				return false
			}
			k.sort((a, b) => moment(this.liveFeed.data[a].openDate).isAfter(this.liveFeed.data[b].openDate) ? -1 : moment(this.liveFeed.data[a].openDate).isBefore(this.liveFeed.data[b].openDate) ? 1 : 0)
			return k
		},
		...mapGetters({
			User: 'user/all',
		})
	},
	created() {
		if (this.currenDayIndex === 6 || this.currenDayIndex === 0) {
			this.liveFeed.disabled = true
			console.log('livefeed is disabled on weekends')
			return
		} else {
			this.liveFeed.disabled = false
		}
	},
	mounted() {
		this.setLiveFeedMode()
		window.addEventListener('resize', this.setLiveFeedMode)
		this.$bus.$on('LiveFeedConnect', this.startWs)
		this.$bus.$on('LiveFeedClose', this.closeWs)
		this.$bus.$on('LiveFeedToggleMode', this.setLiveFeedMode)
	},
	beforeDestroy() {
		this.$bus.$off('LiveFeedConnect', this.startWs)
		this.$bus.$off('LiveFeedClose', this.closeWs)
		this.$bus.$off('LiveFeedToggleMode', this.setLiveFeedMode)
		this.closeWs()
	},
	methods: {
		setLiveFeedMode(force) {
			if (this.liveFeed.empty) {
				return
			}
			if (typeof force === 'boolean' && typeof this.liveFeed.open === 'boolean' && this.liveFeed.open !== null) {
				this.liveFeed.open = force
				return
			}
			var windowWidth = window.innerWidth
			if (windowWidth < 1800) {
				this.liveFeed.open = false
			} else {
				this.liveFeed.open = true
			}
		},
		checkNewLiveFeedIDExists(newFeedID) {
			let newk = Object.keys(this.liveFeed.data)
			for (let i = 0, l = newk.length; i < l; i++) {
				let feedID = this.liveFeed.data[newk[i]]['orderID']
				if (feedID === newFeedID) {
					return newk[i]
				}
			}
			return false
		},
		updateLiveFeedData(data) {
			let olddk = Object.keys(this.liveFeed.data)
			let newk = Object.keys(data)
			// remove old feed(s) if don't exist in new batch
			for (let i = 0, l = olddk.length; i < l; i++) {
				let found = false
				for (let j = 0, g = newk.length; j < g; j++) {
					if (this.liveFeed.data[olddk[i]]){
						if (data[newk[j]]['orderID'] === this.liveFeed.data[olddk[i]]['orderID']) {
							found = true
						}
					}
				}
				if (!found) {
					this.$delete(this.liveFeed.data, olddk[i])
				}
			}

			// let changes = 0
			for (let i = 0, l = newk.length; i < l; i++) {
				let newFeed = data[newk[i]]
				let oldIndex = this.checkNewLiveFeedIDExists(newFeed['orderID'])
				if (oldIndex === false) {
					// new feed, add here
					if (!this.liveFeed.open) {
						this.liveFeed.unseen++
					}
					newFeed.update = true
					let newKey = Math.max(...this.liveFeedSorted)
					newKey++
					var nn = {}
					nn[newKey] = newFeed
					this.liveFeed.data = Object.assign({}, this.liveFeed.data, nn)
				} else {
					let oldFeed = this.liveFeed.data[oldIndex]
					let propK = Object.keys(newFeed)
					let c = false
					// check for property changes
					for (let j = 0, k = propK.length; j < k; j++) {
						// propK[j] !== 'update' &&
						if (propK[j] !== 'likeTotal') {
							if (newFeed[propK[j]] !== oldFeed[propK[j]]) {
								if (!c) {
									// changes++
									c = true
									if (!this.liveFeed.open) {
										this.liveFeed.unseen++
									}
								}
								this.$set(oldFeed, propK[j], newFeed[propK[j]])
								this.$set(oldFeed, 'update', true)
							}
						}
					}
				}
			}
			if (this.liveFeed.open) {
				this.animateUpdate()
			}
		},
		animateUpdate() {
			let feedk = Object.keys(this.liveFeed.data)
			for (let i = 0, l = feedk.length; i < l; i++) {
				let feed = this.liveFeed.data[feedk[i]]
				if (typeof feed.cssClass === 'undefined') {
					this.$set(feed, 'cssClass', [])
				} else {
					feed.cssClass = []
				}
				if (feed.update) {
					feed.cssClass = ['animated', 'fadeInDown']
					feed.update = false
					setTimeout(() => {
						feed.cssClass = []
						// this.$set(feed, 'cssClass', [])
					}, 1000)
				}
			}
		},
		like(index) {
			let feed = this.liveFeed.data[index]
			var data = {
				userID: this.User.info.ID,
				feedID: feed.feedID,
				orderID: String(feed.orderID),
				like: true,
			}

			if (feed.liked) {
				data.like = false
			}

			service.post('/live-feed/like', data)
			.then(response => {
				if (response.data.success) {
					if (data.like) {
						feed.liked = true
						feed.likeTotal++
					} else {
						feed.liked = false
						if (feed.likeTotal > 0) {
							feed.likeTotal--
						}
					}
				}
			})
		},
		closeWs() {
			this.conn.close()
		},
		startWs() {
			if (this.liveFeed.disabled) {
				return
			}
			if (!this.$auth.token()) {
				this.delay.tries.c++
				if (this.delay.tries.c >= this.delay.tries.max) {
					this.delay.tries.c = 0
					return
				}
				clearTimeout(this.delay.n)
				this.delay.n = setTimeout(this.startWs, this.delay.t)
				return
			}
			if (window['WebSocket'] && !this.$route.meta.skipStructure) {
				let closed = this.conn === null
				if (!closed && typeof this.conn.readyState !== 'undefined') {
					closed = this.conn.readyState === 3
				}
				if (closed) {
					this.localLogoLoaderActive = true
					this.conn = new WebSocket(config.ws.feed + '?t=' + this.$auth.token())
					this.conn.onmessage = (evt) => {
						let messages = evt.data.split('\n')
						for (var i = 0; i < messages.length; i++) {
							let data = JSON.parse(messages[i])
							if (Object.keys(data).length <= 0) {
								this.liveFeed.empty = true
								this.localLogoLoaderActive = false
								return
							} else {
								this.liveFeed.empty = false
							}
							if (Object.keys(this.liveFeed.data).length) {
								this.updateLiveFeedData(data)
							} else {
								this.liveFeed.data = data
								if (this.liveFeed.open === null) {
									this.setLiveFeedMode()
								}
							}
							this.localLogoLoaderActive = false
						}
					}
				}
			}
		}
	}
}
</script>


<style lang="scss" scoped>

	#openTradeNewsFeedSection {
		height: 640px;
		width: 330px;
		background-color: #fff;
		border: solid 1px #000;
		padding:15px 0;
		position: fixed;
		right: 20px;
		top: 160px;
		overflow-y: scroll;
		z-index: 99;
		max-height: calc(100vh - 160px);
		div.newsFeed {
			width: 100%;
			background-color: white;
			font-size: 12px;
			display: inline-block;
			margin-bottom: -6px;
			padding:0 15px;
			border-bottom: 1px solid #ccc;
			p.accName {
				font-size: 14px;
			}
			div.newsFeedIconContainer {
				height: 100%;
				width: 20%;
				float: left;
				padding: 10px 10px 0 0;
				div.newsFeedIcon {
					margin-top:4px;
					width: 33px;
					height: 33px;
					background-image: url("../assets/img/icons/newsfeed/profile-pic.svg");
					background-repeat: no-repeat;
					float: right;
				}
			}
			div.newsDataContainer {
				height: 100%;
				width: 80%;
				float: left;
				padding: 10px 10px 10px 0px;

				p.likeIcon {
					width: 14px;
					height: 14px;
					margin: 13px 0 3px 0;
					cursor: pointer;
					background-image: url("../assets/img/icons/newsfeed/like-blk.svg");
					background-repeat: no-repeat;

					&.liked {
						background-image: url("../assets/img/icons/newsfeed/like-red.svg");
					}
				}

				div.clockIcon {
					width: 11px;
					height: 11px;
					margin: 3px 5px 2px 2px;
					float: left;
					background-image: url("../assets/img/icons/newsfeed/time.svg");
					background-repeat: no-repeat;
				}
			}
		}
	}

	#openTradeNewsFeedMini {
		// height: 63px;
		// width: 31px;
		min-width: 40px;
		background-color: #fff;
		border:1px solid #000;
		border-right:none;
		position: fixed;
		right: 0px;
		top: 160px;
		border-radius: 5px 0px 0px 5px;
		z-index: 99;

		&.open {
			right: 349px;
			.miniSubSection#maxButton {
				transform: rotate(0deg)
			}
		}

		.miniSubSection {
			border-radius: 5px;
			margin: 1px;
			cursor: pointer;

			&#newsFeedIcon {
				background-image: url("../assets/img/icons/newsfeed/newsfeed.svg");
				height:25px;
				height:25px;
				margin:7px;
				background-repeat: no-repeat;
			}

			&#newsFeedCounter {
				background-color: #ff0000;
				color: #ffffff;
				border:1px solid #fff;
				text-align: center;
				position: absolute;
				top: -6px;
				left: -6px;
				padding:0 3px;
				line-height: 18px;
				font-size: 11px;
				font-weight: 900;
				min-width: 17px;
			}

			&#maxButton {
				// display: none;
				background-image: url("../assets/img/icons/newsfeed/arrow.svg");
				background-repeat: no-repeat;
				transform: rotate(180deg);
				color: #000000;
				// text-align: center;
				// font-weight: 900;
				// line-height: 30px;
				width:30px;
				height:30px;
				margin:0 auto 0;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// LiveFeed.vue?49ccc966